<template>
  <div>
    <BasicDialog @close="closeDialog">
      <v-row>



        <v-col cols="12" class="d-flex flex-row justify-center align-center">
          <logo-background></logo-background>
          <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
            <img :src="AppConfigs.staticImages.SHAREONTWITTER" alt="Share on Twitter" style="width: 70; height: auto; transform: scale(0.9);">
            <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable" style="position: absolute; top: -27%; left: -26%; transform: scale(0.9
            );">
          </div>
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
          Share on Twitter
        </v-col>



        <v-col cols="12" class="text-center">
          Share on Twitter and earn {{ coinsForSharingOnTwitter }} coins
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center">
          <v-btn rounded="pill" :disabled="!isAvailable"
            class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
            @click="shareOnTwitter">
            Share Now
          </v-btn>
        </v-col>



      </v-row>
    </BasicDialog>
  </div>
</template>




<script>

import { defineComponent } from 'vue';
import { AppConfigs } from "@/app.configs";
import { computed, inject, provide } from 'vue';

import { UserActivityStore } from '@/store/UserActivityStore';

import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";


export default defineComponent({
  name: 'ShareOnTwitterDialog',
  components: {
    BasicDialog,
    LogoBackground,
  },
  props: {
    dialogOpen: Boolean
  },
  setup(props, { emit }) {

    // Hardcoded share message and URL
    let openDialog = inject('inHouseTaskOpenDialog');
    provide('openDialog', openDialog);
    
    const defaultShareMessage = 'Check out this awesome website!';
    const defaultShareUrl = 'https://webappdev.bountyhunterapp.co';

    const inHouseTaskStore = UserActivityStore();
    const coinsForSharingOnTwitter = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
    const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);

    function closeDialog() {
      emit('close');
    }

    function shareOnTwitter() {
      const text = encodeURIComponent(defaultShareMessage);
      const url = encodeURIComponent(defaultShareUrl);
      const twitterIntentUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
      window.open(twitterIntentUrl, '_blank');
      inHouseTaskStore.redeemCoinsForSelectedInHouseTask();
    }

    return {
      AppConfigs,
      closeDialog,
      isAvailable,
      shareOnTwitter,
      coinsForSharingOnTwitter,
    };
  },
});
</script>
